<template>
  <div
    class="anz-mr-l-sm anz-mb-noc-xs anz-mb-xs-sm anz-block-sm anz-flex anz-justify-content-between anz-wf-mo anz-bb-no-last-child-mo anz-pb-s-mo anz-pt-xs-mo"
  >
    <span class="anz-mr-xs anz-strong">
      <slot name="title"></slot>
    </span>
    <span class="anz-align-right">
      <slot name="value"></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'AUserProfileMetaItem',
}
</script>
